import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sun } from 'lucide-react';
export function DreamOutcome() {
  const outcomes = ['Tu contenido atrae al cliente correcto', 'Tu email lo convence de que eres la persona indicada', 'Tu enlace de afiliado convierte en piloto automático', 'Y tus métricas te dicen exactamente qué ajustar cada semana'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800 relative" data-id="element-27">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-28" />

      <div className="max-w-4xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-30">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/10 mb-6 border border-gold-500/20" data-id="element-31">
            <Sun className="w-8 h-8 text-gold-400" data-id="element-32" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8" data-id="element-33">
            El Resultado Que{' '}
            <span className="text-gold-400" data-id="element-34">Sí Es Posible</span>
          </h2>

          <p className="text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto font-light" data-id="element-35">
            Imagina levantarte un martes por la mañana. Abres tu teléfono. Y
            antes de tomarte el café, ya tienes una notificación de comisión. No
            vendiste nada mientras dormías por arte de magia — lo hiciste porque{' '}
            <strong className="text-white font-medium" data-id="element-36">
              construiste un sistema que trabaja para ti.
            </strong>
          </p>
        </motion.div>

        <div className="bg-navy-900/80 border border-gold-500/20 rounded-2xl p-8 sm:p-12 box-glow relative overflow-hidden" data-id="element-37">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-gold-500/10 blur-3xl rounded-full" data-id="element-38" />

          <h3 className="text-2xl font-serif text-white mb-8 relative z-10" data-id="element-39">
            Un sistema donde:
          </h3>

          <div className="space-y-6 relative z-10" data-id="element-40">
            {outcomes.map((outcome, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + index * 0.1,
            duration: 0.5
          }} className="flex items-center space-x-4" data-id="element-41">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold-500/20 flex items-center justify-center border border-gold-500/30" data-id="element-42">
                  <CheckCircle2 className="w-5 h-5 text-gold-400" data-id="element-43" />
                </div>
                <p className="text-lg text-slate-200" data-id="element-44">{outcome}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} className="text-center mt-12" data-id="element-45">
          <p className="text-2xl font-serif text-gold-400 italic" data-id="element-46">
            Eso no es un sueño. Es lo que pasa cuando tienes el mapa correcto.
          </p>
        </motion.div>
      </div>
    </section>;
}